import styled, { device } from '@styled'

export const StyledText = styled.div`
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  b {
    font-weight: 700;
  }
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`

export const StyledText2 = styled.div`
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  margin-block-start: 15px;
  margin-block-end: 15px !important;
  font-size: 18px;
  b {
    font-weight: 700;
  }
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`
